// state.js
import { ref } from 'vue';

export const positionsSL = ref([]);
export const ordersSL = ref([]);
export const binanceSLSummary = ref({});

export const positionsSLLeaders = ref([]);
export const ordersSLLeaders = ref([]);
export const binanceSLSummaryLeaders = ref({});

export const positionsSLFactory = ref([]);
export const ordersSLFactory = ref([]);
export const binanceSLSummaryFactory = ref({});

export const walletBalances = ref([]);
export const walletHistory = ref([]);
export const settings = ref({ fx_usdt_chf: 0.8 });

// --- WebSocket bridge (set from App.vue) ---
let ws = null;

export function setWebSocket(socket) {
    ws = socket;
}

/**
 * English: Request wallet total history from backend (WS).
 * Now resilient: if WS isn't OPEN yet, it retries for a short time.
 */
export function requestWalletHistory(
    { accountId = "all", bucketSec = 300, hours = 168 } = {},
    { retries = 30, retryDelayMs = 200 } = {}
) {
    const payload = {
        type: "wallet_history_request",
        accountId,
        bucketSec,
        hours
    };

    function trySend(remaining) {
        if (ws && ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify(payload));
            return;
        }
        if (remaining <= 0) return;
        setTimeout(() => trySend(remaining - 1), retryDelayMs);
    }

    trySend(retries);
}
